import React from 'react';
import { useNavigate } from 'react-router-dom';
import { PartnerMySubmissionsTab } from './PartnerMySubmissionsTab';

/**
 * Partner: submission history and detail (wireframe "My Submissions" tab).
 */
export function PartnerSubmissionsView() {
  const navigate = useNavigate();
  return (
    <div id="partner-history" className="tab-content active">
      <PartnerMySubmissionsTab
        onStartUpdate={(ctx) => navigate('/partner/submit', { state: { update: ctx } })}
      />
    </div>
  );
}
